// src/firebaseConfig.js
import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    appId: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    measurementId: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  };

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
let messaging;
if (typeof window !== 'undefined' && 'serviceWorker' in navigator && 'PushManager' in window) {
  messaging = getMessaging(app);
} else {
  console.log('This browser doesn\'t support the API\'s required to use the Firebase SDK');
}
//const analytics = getAnalytics(app);

//singOut
const signOut = () => {
  auth.signOut().then(() => {
    console.log('Sign-out successful.');
  }).catch((error) => {
    console.log('An error happened.');
  });
}

export { auth, messaging, signOut };